import Container from "@material-ui/core/Container"
import React from "react"
import useAppStyles from "../styles/appStyle"
import ErrorBoundary from "../pages/error/ErrorBoundary"
import ErrorPage from "../pages/error/ErrorPage"

/**
 * Basic higher order function to wrap a component between the main Container with an ErrorBoundary
 * @param Wrapped
 * @param size
 * @returns {function(*)}
 */
export default function withContainer(Wrapped, size = "lg") {
  // eslint-disable-next-line react/display-name
  return (props) => {
    const classes = useAppStyles()
    return (
      <Container
        maxWidth={size}
        className={`${classes.defaultMainContainer} ${classes.defaultMainContainer3}`}
      >
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <Wrapped {...props} />
        </ErrorBoundary>
      </Container>
    )
  }
}
